import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';

const FsHeaderLarge = withStyles(() =>
  createStyles({
    root: {},
  })
)((props) => <Typography variant="h1" component="h1" {...props} />);

export default FsHeaderLarge;
